import DetailRAB from './DetailRAB';
export default DetailRAB;
